import type { AddonsInsightsReport } from 'model/AddonsInsightsReport';

export interface AddonsInsightsReportState {
    loading: boolean;
    report: AddonsInsightsReport;
}

export const emptyAddonsInsightsReport = (): AddonsInsightsReport => ({
    range: { start: '', end: '' },
    totals: {
        quantity: 0,
        grossSales: 0,
        discounts: 0,
        refunds: 0,
        netSales: 0,
        allNetSales: 0
    },
    meta: {
        page: 1,
        perPage: 10,
        totalCount: 0,
        totalPages: 1
    },
    addons: []
});

export const initialAddonsInsightsReportState: AddonsInsightsReportState = {
    loading: false,
    report: emptyAddonsInsightsReport()
};
